import * as Yup from "yup";
import CorporationZoneModel from "../../models/masters/corporationzone-model";
import { API_END_POINT } from "../../constants";
import { InputField } from "../../components/form/input.field.component";
import { FormikModelDialog, SubmitStatus } from "../../core/formik-model-dialog.component";
import { CheckboxField, CheckBoxStyle } from "../../core/checkbox-field.component";
import { useEffect, useState } from "react";
import { useGetCorporationZone } from "../../apiclient/master/useGetCorporationZoneApi";

interface CorporationZoneEditProps {
  data: CorporationZoneModel;
  isViewMode?: boolean; 
  onClose?: (status: SubmitStatus, data: any) => any;
}

const CorporationZoneEntry: React.FC<CorporationZoneEditProps> = ({ ...props }) => {
  let { data,  onClose,isViewMode } = props;
  const title = data?.corporationZoneId > 0 ? "Edit Corporation Zone" : "Add Corporation Zone";
  
  let initialValue: CorporationZoneModel = {
    corporationZoneId: data?.corporationZoneId? data.corporationZoneId:0,
    name: data?.name,
    isActive: data?.corporationZoneId > 0 ? data.isActive : true,
   
  };
  const validationSchema = Yup.object().shape({
    name: Yup.string()
    .required("Required")
    .test("check-duplicate-name", "CorporationZone name already exists", (value) => {
      // Ensure the value is compared in a case-insensitive manner
      return (
        value &&
        !existingName.some(existing => existing.toLowerCase() === value.toLowerCase()) ||
        (data?.name && value === data.name) // Allow current name during update
      );
    }), 
   });

    const [existingName, setExistingName] = useState<string[]>([]); // state to hold existing zone names
    const { data: fetchedCorporationZone } = useGetCorporationZone();

    useEffect(() => {
      if (fetchedCorporationZone) {
          setExistingName(fetchedCorporationZone.map((zone: any) => zone.name)); // Extracting zone names to compare against
      }
  }, [fetchedCorporationZone]);

  return (
    <>
      <FormikModelDialog
        width="50%"
        title={title}
        initialData={initialValue}
        validationSchema={validationSchema}
        show={!!data}
        onClose={onClose}
        endpoint={API_END_POINT.MASTER}
        postRoute="CorporationZone/SaveCorporationZone"
        showAddAnother={true}
        isViewOnly ={isViewMode}
        isUpDateEntityDetails={data?.corporationZoneId>0? true: false}
      >
        <div>
          <div className="row">
            <div className="col-12">
              <InputField maxLength={100} label="Corporation Zone *" name="name" />
            </div>
            <div className="col-6">
                  <CheckboxField  isChecked={true} label="Is Active?" name="isActive"  checkstyle={CheckBoxStyle.Normal} />
              </div>
            
            </div>
          </div>
        
      </FormikModelDialog>
    </>
  );
};

export default CorporationZoneEntry;
